import { Injectable, inject } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ApiService } from 'src/app/shared/services/api';
import { FetchDistributors, FetchRetailers, FetchRetailersAgain, ResetSelectParty } from './actions';
import { ROUTES_CONFIG } from '@core';
import { tap } from 'rxjs/operators';
import * as immutable from 'object-path-immutable';

const initialState = {};

@State({
	name: 'selectParty',
	defaults: initialState
})

@Injectable()
export class SelectPartyState {
	private _api = inject(ApiService);

  @Action([FetchRetailers, FetchRetailersAgain], { cancelUncompleted: true })
	onFetchRetailers({ setState, getState }: StateContext<any>, { payload }: FetchRetailers | FetchRetailersAgain) {
		const API_URL = ROUTES_CONFIG.GET_RETAILERS;
		return this._api.get(API_URL, {
			params: payload
		}).pipe(
			tap((res: any) => {
				if (res?.status?.toLowerCase() === 'success') {
					setState({
						...getState(),
						retailers: {
							data: res.retailers || [],
							loaded: true,
							totalRecords: res.total_records
						}
					})
				}
			})
		)
	}

  @Action([FetchDistributors], { cancelUncompleted: true })
  onFetchDistributors({ setState, getState }: StateContext<any>, { payload }: FetchDistributors) {
  	const API_URL = ROUTES_CONFIG.GET_DISTRIBUTOR;
  	return this._api.get(API_URL, {
  		params: payload
  	}).pipe(
  		tap((res: any) => {
  			if (res?.status?.toLowerCase() === 'success') {
  				setState({
  					...getState(),
  					distributors: {
  						data: res.distributors || [],
  						loaded: true,
  						totalRecords: res.total_records
  					}
  				})
  			}
  		})
  	)
  }

  @Action(ResetSelectParty, { cancelUncompleted: true })
  onResetSelectParty({ setState, getState }: StateContext<any>, { key }: ResetSelectParty): any {
  	if (!key) {
  		setState({
  			...initialState
  		});
  		return;
  	}

  	const state = immutable.set(
  		getState(),
  		`${key}`,
  		immutable.get(initialState, `${key}`)
  	);

  	setState(state);
  }
}
